import {
    Box,
    Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

export const SMLicense: React.FC = () => {

    const { t } = useTranslation()

    const data = [
        {
            'title': t('t241'),
            'content': t('t242'),
        },
        {
            'title': t('t243'),
            'content': t('t244'),
        },
        {
            'title': t('t245'),
            'content': t('t246'),
        },
        {
            'title': t('t247'),
            'content': t('t248'),
        }
    ]

    const renderItem = (index: number) => {
        return (
            <Box key={index} sx={{
                flex: '1',
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: '12px',
                paddingRight: '12px',
            }}>
                <Typography color={'#6B6B6B'} fontSize={16} fontWeight={400}>
                    {data[index]['title']}
                </Typography>
                <Typography color={'#6B6B6B'} fontSize={16} fontWeight={700}>
                    {data[index]['content']}
                </Typography>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                paddingLeft: '60px',
                paddingRight: '60px',
                paddingTop: '60px',
                paddingBottom: '60px',
            }}
        >
            <Box sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '10px',
                paddingLeft: '38px',
                paddingRight: '38px',
                paddingTop: '50px',
                paddingBottom: '50px',
                boxShadow: '0px 10px 80px 3px #0000001A',
            }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                }}>
                    {data.map((item, index) => (
                        renderItem(index)
                    ))}
                </Box>

                <Typography color={'#6B6B6B'} fontSize={16} fontWeight={600} paddingTop={'40px'} paddingLeft={'12px'} paddingRight={'12px'}>
                    {t('t249')}
                </Typography>
            </Box>

        </Box >
    )
}

// ======================= EXPORT
export default SMLicense
